import { KeyboardArrowDown } from "@mui/icons-material";
import { MenuItem, Select, SelectProps, useTheme } from "@mui/material";
import React from "react";

interface DropdownOption {
  value: number | string;
  label: string;
}

interface DropdownProps extends Omit<SelectProps, "children"> {
  options: DropdownOption[];
}

export const Dropdown: React.FC<DropdownProps> = ({
  options,
  sx,
  ...selectProps
}) => {
  const theme = useTheme();

  return (
    <Select
      IconComponent={KeyboardArrowDown}
      MenuProps={{
        PaperProps: {
          sx: {
            "& .MuiMenuItem-root": {
              fontSize: 14,
              color: theme.colors.text[5],
            },
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: theme.colors.secondary[0],
              fontWeight: 500,
              "&:hover": {
                backgroundColor: theme.colors.secondary[0],
              },
            },
          },
        },
      }}
      size="small"
      sx={{
        maxWidth: 232,
        minWidth: 180,
        width: "100%",
        backgroundColor: theme.colors.secondary[0],
        color: theme.colors.text[5],
        height: 48,
        fontSize: 14,
        fontWeight: 500,
        borderRadius: "16px",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .MuiSelect-icon": {
          marginRight: "14px",
          transition: "transform 0.2s ease-in",
        },
        "& .MuiSelect-iconOpen": {
          transform: "rotate(-180deg)",
        },
        ...sx,
      }}
      variant="outlined"
      {...selectProps}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
